import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { SupplementaryEquipmentResponse, TruckDetails } from './truck.model';

@Injectable({
  providedIn: 'root'
})
export class TruckService {

  constructor(private appServerAPI: AppServerAPI) { }

  public saveTruck(truck: TruckDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/truck/save', truck);
  }

  public getTruckDetails(truckId: number): Observable<TruckDetails> {
    return this.appServerAPI.execute('/client/control/truck/details', truckId);
  }

  public checkLeaveAllowed(truckId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/truck/check-leave', truckId);
  }

  public registerLeave(truckId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute('/client/control/truck/register-leave', truckId);
  }

  public getAvailableSupplementaryEquipments(): Observable<SupplementaryEquipmentResponse> {
    return this.appServerAPI.execute<SupplementaryEquipmentResponse>('/client/control/truck/supplementaryequipment',
      {});
  }

  public findTrucksByNumberplate(numberplate: string): Observable<TruckDetails[]> {
    return this.appServerAPI.execute('/client/control/truck/find', numberplate);
  }
}
